import { useMemo } from 'react';
import { useSubscriptionUsage } from './useSubscriptionUsage';

/**
 * 使用状況を監視し、使用率や警告状態を提供するフック
 */
export function useUsageMonitor() {
  const { data, refetch, isLoading, error } = useSubscriptionUsage();
  const usage = data?.usage;

  // 設備数使用率を計算
  const equipmentUtilization = useMemo(() => {
    if (!usage || usage.equipmentLimit === null) {
      return null;
    }
    return (usage.equipmentCount / usage.equipmentLimit) * 100;
  }, [usage]);

  // 予測枠使用率を計算
  const predictionUtilization = useMemo(() => {
    if (!usage || usage.predictionLimit === null) {
      return null;
    }
    return (usage.predictionCount / usage.predictionLimit) * 100;
  }, [usage]);

  // 上限到達の判定（80%以上で警告）
  const isEquipmentNearLimit = equipmentUtilization !== null && equipmentUtilization >= 80;
  const isPredictionNearLimit = predictionUtilization !== null && predictionUtilization >= 80;

  return {
    usage,
    equipmentUtilization,
    predictionUtilization,
    isEquipmentNearLimit,
    isPredictionNearLimit,
    refetch,
    isLoading,
    error,
  };
}
